import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b59c09fe")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "file-input",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick()))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode("input", {
      class: "input",
      type: "file",
      name: "upload",
      ref: "inputRef",
      accept: _ctx.accept,
      onChange: _cache[1] || (_cache[1] = $event => _ctx.handleChange($event))
    }, null, 40, ["accept"])
  ]))
})